import { useCallback, useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";

const defaultLegendSettings: Record<string, { name: string; visible: boolean }[]> = {
  advertisements: [
    { name: "Impressions", visible: true },
    { name: "Clicks", visible: false },
    { name: "Ad Sales", visible: true },
    { name: "Ad Spend", visible: false },
    { name: "ACOS", visible: false },
    { name: "annotationAxis", visible: true },
    { name: "Page Views", visible: false },
    { name: "Add To Cart", visible: false },
    { name: "Begin Checkout", visible: false },
  ],
  summary: [
    { name: "Impressions", visible: true },
    { name: "Clicks", visible: false },
    { name: "Ad Sales", visible: true },
    { name: "Total Sales", visible: false },
    { name: "Ad Spend", visible: false },
    { name: "ACOS", visible: false },
    { name: "Total ACOS", visible: false },
    { name: "annotationAxis", visible: true },
    { name: "Page Views", visible: false },
    { name: "Add To Cart", visible: false },
    { name: "Begin Checkout", visible: false },
  ],
  category: [
    { name: "Impressions", visible: true },
    { name: "Clicks", visible: false },
    { name: "Ad Sales", visible: true },
    { name: "Total Sales", visible: false },
    { name: "Ad Spend", visible: false },
    { name: "ACOS", visible: false },
    { name: "Total ACOS", visible: false },
    { name: "annotationAxis", visible: true },
    { name: "Page Views", visible: false },
    { name: "Add To Cart", visible: false },
    { name: "Begin Checkout", visible: false },
  ],
  listing: [
    { name: "Impressions", visible: true },
    { name: "Clicks", visible: false },
    { name: "Ad Sales", visible: true },
    { name: "Total Sales", visible: false },
    { name: "Ad Spend", visible: false },
    { name: "ACOS", visible: false },
    { name: "Total ACOS", visible: false },
    { name: "BSR", visible: false },
    { name: "annotationAxis", visible: true },
    { name: "Page Views", visible: false },
    { name: "Add To Cart", visible: false },
    { name: "Begin Checkout", visible: false },
  ],
  merchandiseListing: [
    { name: "Ad Sales", visible: false },
    { name: "Total Sales", visible: true },
    { name: "Ad Spend", visible: false },
    { name: "BSR", visible: true },
    { name: "annotationAxis", visible: true },
    { name: "Product Price", visible: true },
    { name: "Units Ordered", visible: true },
  ],
};

export const useLegend = (chart: string) => {
  const [legends, setLegends] = useLocalStorage("legendOptions", { legends: defaultLegendSettings });

  const setLegend = useCallback(
    (legendOptions: { name: string; visible: boolean }[]) => {
      setLegends({
        legends: {
          ...legends.legends,
          [chart]: legendOptions,
        },
      });
    },
    [chart, legends.legends, setLegends],
  );

  const result = useMemo(() => [legends.legends[chart], setLegend] as const, [chart, legends.legends, setLegend]);

  return result;
};
